import { api } from "./client";

export type Message = {
  id: number;
  room_id: string;
  sender_user_id: string;
  client_msg_uuid: string;
  type: "text" | "image" | "audio" | "video" | "file" | "system";
  content_text: string | null;
  attachment_id: string | null;
  created_at: string;
  deleted_at: string | null;
  /** Solo cliente: estado optimistic */
  _status?: "sending" | "sent" | "failed";
};

export const messagesApi = {
  list: (roomId: string, params: { before_id?: number; after_id?: number; limit?: number } = {}) => {
    const qs = new URLSearchParams();
    if (params.before_id) qs.set("before_id", String(params.before_id));
    if (params.after_id) qs.set("after_id", String(params.after_id));
    if (params.limit) qs.set("limit", String(params.limit));
    const path = `/rooms/${roomId}/messages${qs.toString() ? `?${qs}` : ""}`;
    return api.get<Message[]>(path);
  },
  send: (
    roomId: string,
    payload: { client_msg_uuid: string; type: Message["type"]; content_text?: string; attachment_id?: string },
  ) => api.post<Message>(`/rooms/${roomId}/messages`, payload),
  edit: (roomId: string, messageId: number, content_text: string) =>
    api.patch<Message>(`/rooms/${roomId}/messages/${messageId}`, { content_text }),
  remove: (roomId: string, messageId: number) =>
    api.delete<void>(`/rooms/${roomId}/messages/${messageId}`),
  markRead: (roomId: string, upToId: number) =>
    api.post<{ newly_marked: number }>(`/rooms/${roomId}/read`, { up_to_message_id: upToId }),
};
